import { useEffect, useState } from 'react';

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { fr } from '@/i18n/fr';
import { log } from '@/utils/functions/logger/logger';

export const useI18n = () => {
  const [i18nLoaded, setI18nLoaded] = useState(false);

  useEffect(() => {
    i18n
      .use(initReactI18next)
      .init({
        fallbackLng: 'fr',
        interpolation: {
          escapeValue: false,
        },
        resources: {
          fr,
        },
      })
      .then(() => setI18nLoaded(true))
      .catch((error) => log.error('i18n error', error));
  }, []);

  return { i18nLoaded };
};
